import {
  Box,
  IconButton,
  InputLabel,
  Paper,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Select from '@material-ui/core/Select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  ContentState,
  convertFromRaw,
  convertToRaw,
  EditorState,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import parse from 'html-react-parser';
import htmlToDraft from 'html-to-draftjs';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { AiFillDelete, AiFillEdit, AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import * as Yup from 'yup';
import { ApplicationState } from '~/store';
import { postDocumentRequest } from '~/store/ducks/document/actions';
import getValidationErrors from '~/utils/getValidationErrors';
import '../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { FormControlLGPD, StyledTextField } from '../../styles';

interface PropsModal {
  row?: any;
  action: string;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

interface Sanfona {
  id: string;
  header: string;
  body: string;
}

interface SanfonaStructure {
  sanfona: Sanfona[];
}

const Modal: React.FC<PropsModal> = ({ row, action }) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const dispatch = useDispatch();

  const editorGerenalInformations = useRef<HTMLDivElement>(null);
  const documentoEditorStateRef = useRef<HTMLDivElement>(null);
  const sanfonaEditorStateRef = useRef<HTMLDivElement>(null);

  const documentsData = useSelector<ApplicationState, any>(
    state => state.document,
  );

  const content = {
    blocks: [
      {
        key: '637gr',
        text: 'Desde que estritamente necessário, a SKY coleta os dados que você nos fornece no momento da aquisição de nossos serviços e produtos, tais como nome, endereço, telefone, e-mail, informações bancárias, entre outras.',
        type: 'unordered-list-item',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
      {
        key: '6jsd0',
        text: 'Além disso, quando você utiliza os serviços e plataformas oferecidos pela SKY para fazer compras, por exemplo, algumas informações sobre a transação e/ou dados associados a ela podem ser coletadas, tais como o valor pago e o meio de pagamento utilizado.',
        type: 'unordered-list-item',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
      {
        key: 'fhbmf',
        text: 'Certas informações também podem ser coletadas quando você entra em contato com a SKY, seja através do Serviço de Atendimento ao Consumidor (SAC) ou qualquer outro canal de atendimento, sempre no contexto da prestação dos serviços por você contratados.',
        type: 'unordered-list-item',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
      {
        key: '2ijke',
        text: 'A SKY também pode receber informações sobre você vindas de terceiros que nos permitam, por exemplo, implementar medidas antifraude e de proteção ao crédito.',
        type: 'unordered-list-item',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
      {
        key: '742ak',
        text: 'Caso utilize as plataformas on-line da SKY, também poderão ser coletados cookies, um recurso padrão encontrado em seu navegador de Internet (Ex.: Explorer, Chrome, Firefox, Safari etc.). Os cookies registram a navegação em nossa plataforma e identificam o equipamento utilizado, registrando padrões de navegação e facilitando e agilizando o preenchimento de formulários.',
        type: 'unordered-list-item',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
    ],
    entityMap: {},
  };

  const contentState = convertFromRaw(content);

  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const [safonaData, setSafonaData] = useState<SanfonaStructure>({
    sanfona: [],
  });

  const [formErr, setFormErr] = useState<any>({});

  const auth = useSelector<ApplicationState, any>(state => state.auth);

  const profile = useSelector<ApplicationState, any>(
    state => state.user.profile,
  );

  const TratamentoAtividade = useSelector<ApplicationState, any>(
    state => state.ManterAtividadesTratamentoDados,
  );

  interface FormContact {
    document_title: string;
    document_subtitle: string;
    sanfona_title: string;
    sanfona_subtitle: string;
    sanfona_header: string;
  }

  const [form, setForm] = useState<FormContact>({
    document_title: '',
    document_subtitle: '',
    sanfona_title: '',
    sanfona_subtitle: '',
    sanfona_header: '',
  });

  const handleChangeInput = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const target = event.target;
      const name = target.name;

      setFormErr({
        ...formErr,
        [name]: false,
      });

      setForm({
        ...form,
        [name]: target.value,
      });

      if (name === 'sanfona_header') {
        setFormErr({
          ...formErr,
          [name]: false,
          safonaData: false,
        });
      }
    },
    [form, formErr],
  );

  const [editorState, setEditorState] = useState({
    documentoEditorState:
      documentsData.changeInsert === 'change'
        ? EditorState.createWithContent(contentState)
        : EditorState.createEmpty(),
    sanfonaEditorState:
      documentsData.changeInsert === 'change'
        ? EditorState.createWithContent(contentState)
        : EditorState.createEmpty(),
    generalInformationSanfonaEditorState:
      documentsData.changeInsert === 'change'
        ? EditorState.createWithContent(contentState)
        : EditorState.createEmpty(),
  });

  const statusTypses = ['Ativado', 'Desativado'];

  const [status, setStatus] = useState({
    statusDocumen: 0,
    statusSanfona: 0,
  });

  const resetModal = useCallback(() => {
    setValue(0);

    setStatus({
      statusDocumen: 0,
      statusSanfona: 0,
    });

    setForm({
      document_title: '',
      document_subtitle: '',
      sanfona_title: '',
      sanfona_subtitle: '',
      sanfona_header: '',
    });

    setSafonaData({ sanfona: [] });

    setEditorState({
      documentoEditorState: EditorState.createEmpty(),
      sanfonaEditorState: EditorState.createEmpty(),
      generalInformationSanfonaEditorState: EditorState.createEmpty(),
    });
  }, []);

  useEffect(() => {
    if (documentsData.editData) {
      const documentStateData = JSON.parse(
        documentsData.editData.page_content_ds,
      );

      if (documentsData.changeInsert === 'change') {
        if (documentsData.editData.page_type_fl === 1) {
          setValue(0);

          setStatus({
            statusSanfona: 0,
            statusDocumen: documentsData.editData.status_fl === 'Y' ? 1 : 2,
          });

          setForm({
            sanfona_title: '',
            sanfona_subtitle: '',
            sanfona_header: '',
            document_title: documentStateData.document_title,
            document_subtitle: documentStateData.document_subtitle,
          });

          setSafonaData({ sanfona: [] });

          const contentBlock = htmlToDraft(
            documentStateData.documentoEditorState,
          );
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks,
          );

          const editorStateDocument =
            EditorState.createWithContent(contentState);

          setEditorState({
            ...editorState,
            documentoEditorState: editorStateDocument,
            sanfonaEditorState: EditorState.createEmpty(),
            generalInformationSanfonaEditorState: EditorState.createEmpty(),
          });
        }

        if (documentsData.editData.page_type_fl === 2) {
          setValue(1);

          setStatus({
            statusDocumen: 0,
            statusSanfona: documentsData.editData.status_fl === 'Y' ? 1 : 2,
          });

          setForm({
            document_title: '',
            document_subtitle: '',
            sanfona_header: '',
            sanfona_title: documentStateData.sanfona_title,
            sanfona_subtitle: documentStateData.sanfona_subtitle,
          });

          const contentBlock = htmlToDraft(
            documentStateData.generalInformationSanfonaEditorState,
          );
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks,
          );

          const editorStateGeneralInformationSanfona =
            EditorState.createWithContent(contentState);

          setEditorState({
            ...editorState,
            documentoEditorState: EditorState.createEmpty(),
            generalInformationSanfonaEditorState:
              editorStateGeneralInformationSanfona,
          });

          const editSafonaData =
            documentStateData.sanfonaEditorState.sanfona.map((el: any) => {
              return {
                id: el.id,
                header: el.header,
                body: el.body,
              };
            });

          setSafonaData({ sanfona: editSafonaData });
        }
      } else {
        resetModal();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentsData.changeInsert, documentsData.editData]);

  const documentoOnEditorStateChange = useCallback(
    onEditorState => {
      setEditorState({ ...editorState, documentoEditorState: onEditorState });

      setFormErr({
        ...formErr,
        documentoEditorState: false,
      });
    },
    [editorState, formErr],
  );

  const sanfonaOnEditorStateChange = useCallback(
    onEditorState => {
      setEditorState({ ...editorState, sanfonaEditorState: onEditorState });

      setFormErr({
        ...formErr,
        sanfonaEditorState: false,
      });
    },
    [editorState, formErr],
  );

  const generalInformationSanfonaOnEditorStateChange = useCallback(
    onEditorState => {
      setEditorState({
        ...editorState,
        generalInformationSanfonaEditorState: onEditorState,
      });

      setFormErr({
        ...formErr,
        generalInformationSanfonaEditorState: false,
      });
    },
    [editorState, formErr],
  );

  const addItem = useCallback(async () => {
    try {
      const sanfonaEditorState =
        sanfonaEditorStateRef.current?.lastElementChild?.lastElementChild
          ?.textContent;

      const data = {
        ...form,
        sanfonaEditorState: sanfonaEditorState,
      };

      const schema = Yup.object().shape({
        sanfona_header: Yup.string().required('Campo obrigatorio!'),
        sanfonaEditorState: Yup.string().required('Campo obrigatorio!'),
      });

      await schema.validate(data, { abortEarly: false });

      setSafonaData({
        ...safonaData,
        sanfona: [
          ...safonaData.sanfona,
          {
            id: uuidv4(),
            header: form.sanfona_header,
            body: draftToHtml(
              convertToRaw(editorState.sanfonaEditorState.getCurrentContent()),
            ),
          },
        ],
      });

      setForm({ ...form, sanfona_header: '' });
      setEditorState({
        ...editorState,
        sanfonaEditorState: EditorState.createEmpty(),
      });
    } catch (e) {
      if (e instanceof Yup.ValidationError) {
        const err = getValidationErrors(e);

        toast.error('Necessário o preenchimento dos campos de identificação.');

        setFormErr(err);
      }
    }
  }, [editorState, form, safonaData]);

  const removeSanfona = useCallback(
    item => {
      const removed = safonaData.sanfona.filter(el => el.id !== item.id);

      setSafonaData({
        ...safonaData,
        sanfona: removed,
      });
    },
    [safonaData],
  );

  const editSanfona = useCallback(
    item => {
      const indexEdit = safonaData.sanfona.findIndex(el => el.id === item.id);

      const contentBlockSafona = htmlToDraft(
        safonaData.sanfona[indexEdit].body,
      );
      const contentStateSafona = ContentState.createFromBlockArray(
        contentBlockSafona.contentBlocks,
      );

      const editorStateDocumentSafona =
        EditorState.createWithContent(contentStateSafona);

      setEditorState({
        ...editorState,
        sanfonaEditorState: editorStateDocumentSafona,
      });

      setForm({
        ...form,
        sanfona_header: safonaData.sanfona[indexEdit].header,
      });

      const removed = safonaData.sanfona.filter(el => el.id !== item.id);

      setSafonaData({
        ...safonaData,
        sanfona: removed,
      });
    },
    [editorState, form, safonaData],
  );

  const handleChangeDocumentStatus = useCallback(
    (
      event: React.ChangeEvent<{
        name?: string | undefined;
        value: any;
      }>,
    ) => {
      // console.log(event.target.value);
      setFormErr({
        ...formErr,
        statusDocumen: false,
        statusSanfona: false,
      });
      setStatus({ ...status, statusDocumen: event.target.value });
    },
    [formErr, status],
  );

  const handleChangeSanfonaStatus = useCallback(
    (
      event: React.ChangeEvent<{
        name?: string | undefined;
        value: any;
      }>,
    ) => {
      setFormErr({
        ...formErr,
        statusDocumen: false,
        statusSanfona: false,
      });
      setStatus({ ...status, statusSanfona: event.target.value });
    },
    [formErr, status],
  );

  const addDocument = useCallback(async () => {
    try {
      const documentoEditorState =
        documentoEditorStateRef.current?.lastElementChild?.lastElementChild
          ?.textContent;

      const data = {
        ...form,
        statusDocumen: status.statusDocumen,
        documentoEditorState: documentoEditorState,
      };

      const schema = Yup.object().shape({
        document_title: Yup.string().required('Campo obrigatorio!'),
        document_subtitle: Yup.string().required('Campo obrigatorio!'),
        documentoEditorState: Yup.string().required('Campo obrigatorio!'),
        statusDocumen: Yup.string().test(
          'statusDocumen',
          'Campo obrigatorio!',
          value => {
            return value !== '0' && value !== '' ? true : false;
          },
        ),
      });

      await schema.validate(data, { abortEarly: false });

      dispatch(
        postDocumentRequest({
          page_type_fl: '1',
          status_fl: status.statusDocumen == 1 ? 'Y' : 'N',
          country_company_id: auth.company?.country_company_id,
          user_executor: profile?.sub,
          page_nm: form.document_title,
          page_content_ds: {
            document_title: form.document_title,
            document_subtitle: form.document_subtitle,
            documentoEditorState: draftToHtml(
              convertToRaw(
                editorState.documentoEditorState.getCurrentContent(),
              ),
            ),
          },
        }),
      );

      resetModal();
      closeButtonRef.current?.click();
    } catch (e) {
      if (e instanceof Yup.ValidationError) {
        const err = getValidationErrors(e);

        toast.error('Necessário o preenchimento dos campos de identificação.');

        setFormErr(err);
      }
    }
  }, [
    auth.company,
    dispatch,
    editorState.documentoEditorState,
    form,
    profile,
    resetModal,
    status.statusDocumen,
  ]);

  const addSanfona = useCallback(async () => {
    try {
      const generalInformationSanfonaEditorState =
        editorGerenalInformations.current?.lastElementChild?.lastElementChild
          ?.textContent;

      const data = {
        ...form,
        statusSanfona: status.statusSanfona,
        safonaData: safonaData.sanfona.length,
        generalInformationSanfonaEditorState:
          generalInformationSanfonaEditorState,
      };

      const schema = Yup.object().shape({
        sanfona_title: Yup.string().required('Campo obrigatorio!'),
        sanfona_subtitle: Yup.string().required('Campo obrigatorio!'),
        generalInformationSanfonaEditorState:
          Yup.string().required('Campo obrigatorio!'),
        statusSanfona: Yup.string().test(
          'statusSanfona',
          'Campo obrigatorio!',
          value => {
            return value !== '0' && value !== '' ? true : false;
          },
        ),
        safonaData: Yup.string().test(
          'safonaData',
          'Campo obrigatorio!',
          value => (value > 0 ? true : false),
        ),
      });

      await schema.validate(data, { abortEarly: false });

      dispatch(
        postDocumentRequest({
          page_type_fl: '2',
          status_fl: status.statusSanfona == 1 ? 'Y' : 'N',
          country_company_id: auth.company?.country_company_id,
          user_executor: profile?.sub,
          page_nm: form.sanfona_title,
          page_content_ds: {
            sanfona_title: form.sanfona_title,
            sanfona_subtitle: form.sanfona_subtitle,
            generalInformationSanfonaEditorState: draftToHtml(
              convertToRaw(
                editorState.generalInformationSanfonaEditorState.getCurrentContent(),
              ),
            ),
            sanfonaEditorState: safonaData,
          },
        }),
      );

      resetModal();
      closeButtonRef.current?.click();
    } catch (e) {
      if (e instanceof Yup.ValidationError) {
        const err = getValidationErrors(e);

        toast.error('Necessário o preenchimento dos campos de identificação.');

        setFormErr(err);
      }
    }
  }, [
    auth.company,
    dispatch,
    editorState.generalInformationSanfonaEditorState,
    form,
    profile,
    resetModal,
    safonaData,
    status.statusSanfona,
  ]);

  const updateSanfona = useCallback(async () => {
    try {
      const generalInformationSanfonaEditorState =
        editorGerenalInformations.current?.lastElementChild?.lastElementChild
          ?.textContent;

      const data = {
        ...form,
        statusSanfona: status.statusSanfona,
        safonaData: safonaData.sanfona.length,
        generalInformationSanfonaEditorState:
          generalInformationSanfonaEditorState,
      };

      const schema = Yup.object().shape({
        sanfona_title: Yup.string().required('Campo obrigatorio!'),
        sanfona_subtitle: Yup.string().required('Campo obrigatorio!'),
        generalInformationSanfonaEditorState:
          Yup.string().required('Campo obrigatorio!'),
        statusSanfona: Yup.string().test(
          'statusSanfona',
          'Campo obrigatorio!',
          value => {
            return value !== '0' && value !== '' ? true : false;
          },
        ),
        safonaData: Yup.string().test(
          'safonaData',
          'Campo obrigatorio!',
          value => (value > 0 ? true : false),
        ),
      });

      await schema.validate(data, { abortEarly: false });

      dispatch(
        postDocumentRequest({
          page_id: documentsData.editData?.page_id,
          page_type_fl: '2',
          status_fl: status.statusSanfona == 1 ? 'Y' : 'N',
          country_company_id: auth.company?.country_company_id,
          user_executor: profile?.sub,
          page_nm: form.sanfona_title,
          page_content_ds: {
            sanfona_title: form.sanfona_title,
            sanfona_subtitle: form.sanfona_subtitle,
            generalInformationSanfonaEditorState: draftToHtml(
              convertToRaw(
                editorState.generalInformationSanfonaEditorState.getCurrentContent(),
              ),
            ),
            sanfonaEditorState: safonaData,
          },
        }),
      );

      resetModal();
      closeButtonRef.current?.click();
    } catch (e) {
      if (e instanceof Yup.ValidationError) {
        const err = getValidationErrors(e);

        toast.error('Necessário o preenchimento dos campos de identificação.');

        setFormErr(err);
      }
    }
  }, [
    auth.company,
    dispatch,
    documentsData.editData,
    editorState.generalInformationSanfonaEditorState,
    form,
    profile,
    resetModal,
    safonaData,
    status.statusSanfona,
  ]);

  const updateDocument = useCallback(async () => {
    try {
      const documentoEditorState =
        documentoEditorStateRef.current?.lastElementChild?.lastElementChild
          ?.textContent;

      const data = {
        ...form,
        statusDocumen: status.statusDocumen,
        documentoEditorState: documentoEditorState,
      };

      const schema = Yup.object().shape({
        document_title: Yup.string().required('Campo obrigatorio!'),
        document_subtitle: Yup.string().required('Campo obrigatorio!'),
        documentoEditorState: Yup.string().required('Campo obrigatorio!'),
        statusDocumen: Yup.string().test(
          'statusDocumen',
          'Campo obrigatorio!',
          value => {
            return value !== '0' && value !== '' ? true : false;
          },
        ),
      });

      await schema.validate(data, { abortEarly: false });

      dispatch(
        postDocumentRequest({
          page_id: documentsData.editData?.page_id,
          page_type_fl: '1',
          status_fl: status.statusDocumen == 1 ? 'Y' : 'N',
          country_company_id: auth.company?.country_company_id,
          user_executor: profile?.sub,
          page_nm: form.document_title,
          page_content_ds: {
            document_title: form.document_title,
            document_subtitle: form.document_subtitle,
            documentoEditorState: draftToHtml(
              convertToRaw(
                editorState.documentoEditorState.getCurrentContent(),
              ),
            ),
          },
        }),
      );

      resetModal();
      closeButtonRef.current?.click();
    } catch (e) {
      if (e instanceof Yup.ValidationError) {
        const err = getValidationErrors(e);

        toast.error('Necessário o preenchimento dos campos de identificação.');

        setFormErr(err);
      }
    }
  }, [
    auth.company,
    dispatch,
    documentsData.editData,
    editorState.documentoEditorState,
    form,
    profile,
    resetModal,
    status.statusDocumen,
  ]);

  return (
    <div
      className="modal-lgpd modal fade"
      id="exampleModal"
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-lgpd" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title"
              id="exampleModalLabel"
              style={{ fontSize: '2rem', fontWeight: 'bold' }}
            >
              {TratamentoAtividade.changeInsert === 'change'
                ? 'Editar documento'
                : 'Incluir documento'}
            </h5>
            <button
              type="button"
              className="close button-close-modal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Paper square>
              <Tabs
                value={value}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                aria-label="tipo de documentos"
              >
                <Tab label="Documento" />
                <Tab label="Sanfona" />
              </Tabs>

              <TabPanel value={value} index={0}>
                <FormControlLGPD
                  variant="outlined"
                  error={!!formErr?.statusDocumen ? true : false}
                >
                  <InputLabel htmlFor="ownershipType">Status</InputLabel>
                  <Select
                    native
                    value={status.statusDocumen}
                    onChange={handleChangeDocumentStatus}
                    label="Status"
                    inputProps={{
                      name: 'status',
                      id: 'status',
                    }}
                  >
                    <option aria-label="ownershipType" value="" />
                    {statusTypses.map((el, i) => {
                      if (!!el) {
                        return (
                          <option key={i} value={(i += 1)}>
                            {el}
                          </option>
                        );
                      }
                    })}
                  </Select>
                </FormControlLGPD>

                <StyledTextField
                  error={!!formErr?.document_title ? true : false}
                  onChange={handleChangeInput}
                  id="title"
                  label="Titulo"
                  name="document_title"
                  value={form.document_title}
                  variant="outlined"
                  className="TextField-lgpd"
                />

                <StyledTextField
                  error={!!formErr?.document_subtitle ? true : false}
                  onChange={handleChangeInput}
                  id="subtitle"
                  label="Subtitulo"
                  name="document_subtitle"
                  value={form.document_subtitle}
                  variant="outlined"
                  className="TextField-lgpd"
                />

                <span>Documento</span>

                <div
                  id="InformaçõesGerais"
                  ref={documentoEditorStateRef}
                  style={{
                    border: `${
                      !!formErr.documentoEditorState ? '1px solid red' : 'none'
                    }`,
                  }}
                >
                  <Editor
                    editorState={editorState.documentoEditorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    onEditorStateChange={documentoOnEditorStateChange}
                  />
                </div>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <FormControlLGPD
                  variant="outlined"
                  error={!!formErr?.statusSanfona ? true : false}
                >
                  <InputLabel htmlFor="ownershipType">Status</InputLabel>
                  <Select
                    native
                    value={status.statusSanfona}
                    onChange={handleChangeSanfonaStatus}
                    label="Status"
                    inputProps={{
                      name: 'status',
                      id: 'status',
                    }}
                  >
                    <option aria-label="ownershipType" value="" />
                    {statusTypses.map((el, i) => {
                      if (!!el) {
                        return (
                          <option key={i} value={(i += 1)}>
                            {el}
                          </option>
                        );
                      }
                    })}
                  </Select>
                </FormControlLGPD>

                <StyledTextField
                  error={!!formErr?.sanfona_title ? true : false}
                  onChange={handleChangeInput}
                  id="title"
                  label="Titulo"
                  name="sanfona_title"
                  value={form.sanfona_title}
                  variant="outlined"
                  className="TextField-lgpd"
                />

                <StyledTextField
                  error={!!formErr?.sanfona_subtitle ? true : false}
                  onChange={handleChangeInput}
                  id="subtitle"
                  label="Subtitulo"
                  name="sanfona_subtitle"
                  value={form.sanfona_subtitle}
                  variant="outlined"
                  className="TextField-lgpd"
                />

                <span>Informações gerais</span>

                <div
                  id="InformaçõesGerais"
                  ref={editorGerenalInformations}
                  style={{
                    border: `${
                      !!formErr.generalInformationSanfonaEditorState
                        ? '1px solid red'
                        : 'none'
                    }`,
                  }}
                >
                  <Editor
                    editorState={
                      editorState.generalInformationSanfonaEditorState
                    }
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    onEditorStateChange={
                      generalInformationSanfonaOnEditorStateChange
                    }
                  />
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderTop: '1px #d8d8d8 solid',
                    paddingTop: '4px',
                  }}
                >
                  <h3>Sanfona</h3>
                  <IconButton color="primary" onClick={addItem}>
                    <AiOutlinePlus size={30} />
                  </IconButton>
                </div>

                <StyledTextField
                  error={!!formErr?.sanfona_header ? true : false}
                  onChange={handleChangeInput}
                  id="header"
                  label="Titulo"
                  name="sanfona_header"
                  value={form.sanfona_header}
                  variant="outlined"
                  className="TextField-lgpd"
                  style={{ marginBottom: 20 }}
                />

                <span>Descrição</span>

                <div
                  id="InformaçõesGerais"
                  ref={sanfonaEditorStateRef}
                  style={{
                    border: `${
                      !!formErr.sanfonaEditorState ? '1px solid red' : 'none'
                    }`,
                  }}
                >
                  <Editor
                    editorState={editorState.sanfonaEditorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    onEditorStateChange={sanfonaOnEditorStateChange}
                  />
                </div>

                {!!formErr?.safonaData ? (
                  <div>
                    <p style={{ color: '#f44336' }}>
                      Obrigatorio ter uma ou mais safona
                    </p>
                  </div>
                ) : (
                  ''
                )}

                <div className="faq-question">
                  {safonaData.sanfona.map(el => (
                    <ExpansionPanel key={el.id}>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                          }}
                        >
                          <Typography className="title">{el.header}</Typography>

                          <div>
                            <IconButton
                              color="primary"
                              onClick={() => editSanfona(el)}
                            >
                              <AiFillEdit />
                            </IconButton>
                            <IconButton
                              color="primary"
                              onClick={() => {
                                removeSanfona(el);
                              }}
                            >
                              <AiFillDelete />
                            </IconButton>
                          </div>
                        </div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        {parse(el.body)}
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  ))}
                </div>
              </TabPanel>
            </Paper>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              ref={closeButtonRef}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                if (TratamentoAtividade.changeInsert === 'change') {
                  value === 0 ? updateDocument() : updateSanfona();
                } else {
                  value === 0 ? addDocument() : addSanfona();
                }
              }}
            >
              {TratamentoAtividade.changeInsert === 'change'
                ? 'Salvar alteração'
                : 'Incluir'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
